import { Injectable, inject } from '@angular/core';
import { HttpClientService } from '@core/services/http-client.service';
import { Router } from '@angular/router';
import { InterVuRequestAQuote } from '@core/models/IntervuRequestAQuote';
import { IntervuRequestAQuoteDto } from '@core/models/dto/IntervuRequestAQuoteModelDto';
import { JsonFormatterService } from '@booking/common/json-formatter.service';
import { tap } from 'rxjs';
import { MessageService } from '@core/services/message.service';

@Injectable({
  providedIn: 'root'
})
export class RequestAQuoteIntervuService {
  private httpClientService = inject(HttpClientService);
  private router = inject(Router);
  private jsonFormatter = inject(JsonFormatterService);
  private messageService = inject(MessageService);

  private mapObjectBeforSending(intervuRequestAQuote: InterVuRequestAQuote) {
    const input = intervuRequestAQuote.getRawValue();
    let res = {
      coordinator: input.coordinator,
      contactDetail: input.contactDetail,
      usabilityStudy: input.usabilityStudy,
      interviewTypeId: Number(input.interviewTypeId),
      usingCamerasId: Number(input.usingCamerasId),
      requestAQuoteOnlineRespondentMarkets: input.respondentMarkets.map((market: any) => {
        const humanTranscript = input.humanTranscript.transcript
          ? {
              languageOptionId: input.humanTranscript.languageOptionId,
              deliveryOptionId: input.humanTranscript.deliveryOptionId,
            }
          : undefined;
        const marketDetails = {
          country: market.country,
          numberOfSessions: Number(market.numberOfSessions),
          sessionLength: Number(market.sessionLength),
        };
        return humanTranscript
          ? { humanTranscript, requestAQuoteOnlineRespondentMarketDetail: marketDetails }
          : { requestAQuoteOnlineRespondentMarketDetail: marketDetails };
      }),
    };
  
    return this.jsonFormatter.cleanData(res);
  }

  public save$(bookOnlineResearchRequest: InterVuRequestAQuote) {
    const mappedObj: IntervuRequestAQuoteDto = this.mapObjectBeforSending(bookOnlineResearchRequest);
    return this.httpClientService.post(mappedObj, 'RequestAQuote/online').pipe(
      tap(() => this.router.navigate(['/thank-you']))
    );
  }
}
